module.exports = __webpack_public_path__ + "img/18@2x.8454b31b.png";